import type { LiabilityFormLayout } from "../types";

export const ownership = (): LiabilityFormLayout => ({
  children: (_state) => [
    { render: 'ownedByCompany' },
    //{
    //  children: (state) =>
    //    state.ownedByCompany
    //      ? [
    //          !!state.ownedByCompany && { render: 'parentId' },
    //          !!state.ownedByCompany && !!state.parentId && ownershipStructure
    //        ]
    //      : []
    //}
  ]
})
